var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "text_head"
  }, [_vm._v("Total Pickup Request: "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.totalShipment))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('toggle-switch', {
    attrs: {
      "options": _vm.myOptions
    },
    on: {
      "change": function($event) {
        _vm.updateMap($event.value)
      }
    }
  })], 1)])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-2 col-sm-6 py-2 container"
  }, [_c('div', {
    staticClass: "card bg-success text-white h-100"
  }, [_c('div', {
    staticClass: "card-body bg-info"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-truck fa-4x"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "status-text"
  }, [_vm._v("Pickup Not Generated")]), _vm._v(" "), _c('h2', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.showData('pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.pendingForPickupGenerationShipment))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-sm-6 py-2 container"
  }, [_c('div', {
    staticClass: "card bg-success text-white h-100"
  }, [_c('div', {
    staticClass: "card-body bg-warning"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-truck fa-4x"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "status-text"
  }, [_vm._v("Allocation Pending")]), _vm._v(" "), _c('h2', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.showData('pickupgenerated')
      }
    }
  }, [_vm._v(_vm._s(_vm.pendingForPickupAllocationShipment))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-sm-6 py-2 container"
  }, [_c('div', {
    staticClass: "card bg-success text-white h-100"
  }, [_c('div', {
    staticClass: "card-body bg-primary"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-truck fa-4x"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "status-text"
  }, [_vm._v("Allocated to SR")]), _vm._v(" "), _c('h2', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.showData('pickupassign')
      }
    }
  }, [_vm._v(_vm._s(_vm.allocatedShipment))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-sm-6 py-2 container"
  }, [_c('div', {
    staticClass: "card bg-success text-white h-100"
  }, [_c('div', {
    staticClass: "card-body bg-success"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-truck fa-4x"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "status-text"
  }, [_vm._v("Pick Done")]), _vm._v(" "), _c('h2', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.showData('pickdone')
      }
    }
  }, [_vm._v(_vm._s(_vm.pickDoneShipment))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-sm-6 py-2 container"
  }, [_c('div', {
    staticClass: "card bg-success text-white h-100"
  }, [_c('div', {
    staticClass: "card-body bg-danger"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-truck fa-4x"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "status-text"
  }, [_vm._v("Cancelled")]), _vm._v(" "), _c('h2', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.showData('cancelled')
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelledShipment))])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isPieLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isPieLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.isPieChartDataAvailable) ? _c('div', {
    staticClass: "pie-chart"
  }, [_c('pie-chart', {
    attrs: {
      "data": _vm.chartData,
      "height": 140,
      "options": _vm.chartOptions
    }
  })], 1) : _vm._e()], 1)])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b53c10d0","hasScoped":true}!./src/modules/cargoallocation/views/dashboard/dashboard.component.html
// module id = 1114
// module chunks = 3